import React, { forwardRef } from 'react';
import { Button, Select } from 'antd';

/**
 * 與模板選單（TemplateTab Input 模式）一致：有選值時在右側顯示「清除」；無選值時不顯示。
 */
const SelectWithClearButton = forwardRef((props, ref) => {
  const {
    value,
    onChange,
    onBlur,
    disabled,
    clearText,
    style,
    children,
    allowClear,
    ...selectProps
  } = props;

  void allowClear;

  const hasValue =
    value !== undefined &&
    value !== null &&
    !(typeof value === 'string' && value.length === 0);

  return (
    <div style={{ display: 'flex', width: '100%', alignItems: 'center', gap: 8, ...style }}>
      <Select
        ref={ref}
        {...selectProps}
        style={{ flex: 1, minWidth: 0, ...(selectProps.style || {}) }}
        value={value}
        onChange={onChange}
        onBlur={onBlur}
        disabled={disabled}
        allowClear={false}
      >
        {children}
      </Select>
      {hasValue && (
        <Button
          type="text"
          size="small"
          disabled={disabled}
          onClick={() => onChange?.(undefined)}
          style={{ flexShrink: 0, padding: '0 4px', fontSize: 12 }}
        >
          {clearText}
        </Button>
      )}
    </div>
  );
});

SelectWithClearButton.displayName = 'SelectWithClearButton';

export default SelectWithClearButton;
